/**
 * Registro simples de alvos do tour que vivem FORA da Home — em especial os
 * botões da BottomBar, que é renderizada pelo layout de abas (app/(tabs)/_layout)
 * e não é alcançável pelos refs da Home. A BottomBar registra cada nó aqui via
 * `setTourTarget(...)` e o tour da Home mede cada um com measureInWindow.
 *
 * WEB: os nós são elementos DOM; o tour mede com getBoundingClientRect().
 *
 * Chaves usadas: `bottombar:home`, `bottombar:arquivos`, `bottombar:camera`,
 * `bottombar:suporte`, `bottombar:menu`.
 */
const targets: Record<string, HTMLElement | null> = {};

export const setTourTarget = (key: string, node: HTMLElement | null) => {
  targets[key] = node;
};

export const getTourTarget = (key: string): HTMLElement | null => targets[key] ?? null;
